import React, { useEffect, useState, useRef } from 'react';
import ServiceBanner from '../../components/ServiceBanner';
import ServicePlan from '../../components/ServicePlan';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import ServicePremium from '../../components/ServicePremimum';

const Service = () => {

  const [seoData, setSeoData] = useState({});
  const [premiumLoaded, setPremiumLoaded] = useState(false);
  const location = useLocation();
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("service");
        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSeoData();
  }, []);

  useEffect(() => {
    if (!premiumLoaded) return;

    const hash = location.hash;
    if (!hash) return;

    const id = hash.replace("#", "");

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    const scrollToElement = () => {
      let element = document.getElementById(id);

      if (!element) {
        const idMap = {
          'starter': ['starter', 'starter-program'],
          'signature': ['signature', 'signature-program-with-genetic-testing'],
          'signature-plus': ['signature-plus', 'signature-program-with-genetic-&-gut-testing']
        };

        const alternatives = idMap[id] || [];
        for (const altId of alternatives) {
          if (altId !== id) {
            const altElement = document.getElementById(altId);
            if (altElement) {
              element = altElement;
              break;
            }
          }
        }
      }

      if (element) {
        const offset = 120;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        return true;
      }
      return false;
    };

    let found = scrollToElement();

    if (!found) {
      let attempts = 0;
      const maxAttempts = 15;

      const retryScroll = () => {
        attempts++;
        const success = scrollToElement();

        if (success || attempts >= maxAttempts) {
          if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
          }
          return;
        }
        scrollTimeoutRef.current = setTimeout(retryScroll, 500);
      };

      scrollTimeoutRef.current = setTimeout(retryScroll, 300);
    }

    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = null;
      }
    };
  }, [premiumLoaded, location.hash]);

  return (
    <div>
      <Helmet>
        <title>{seoData.metaTitle || "Services | Nutrillion"}</title>
      </Helmet>

      <ServiceBanner />

      <ServicePremium
        onLoaded={() => {
          setPremiumLoaded(true);
        }}
      />

      <ServicePlan />
    </div>
  );
}

export default Service;